import React from 'react';
import Dropdown from './Dropdown';
import { TEBLIGAT_OPTIONS } from '../constants/constants';

const TebligatDropdown = ({ setValue, value }) => {
    return (
        <Dropdown
            setSelectedOption={setValue}
            selectedOption={value}
            label="Tebligat Türünü Seçiniz"
            options={TEBLIGAT_OPTIONS}
        />
    );
};

export default TebligatDropdown;
